import { render } from "./SessionDetailComponentMarch24English.vue?vue&type=template&id=593a87bf&scoped=true"
import script from "./SessionDetailComponentMarch24English.vue?vue&type=script&lang=js"
export * from "./SessionDetailComponentMarch24English.vue?vue&type=script&lang=js"

import "./SessionDetailComponentMarch24English.vue?vue&type=style&index=0&id=593a87bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593a87bf"]])

export default __exports__